import { styled } from '@material-ui/core/styles';

export const MobileKeyboardInputView = styled('div')(
  {
    padding: '16px 24px',
  },
  { name: 'MuiPickersMobileKeyboardInputView' }
);
